import './index.scss'

import { initApp, setActiveNav } from 'app/js/app'

setActiveNav()
$(() => {
  initApp()
  // 展开弹框
  $('#buy_cloudpods').click(function () {
    $('#subscription-body').addClass('body-fixed')
    $('#cloud-mask').addClass('display-block')
  })
  // 关闭弹框
  $('.mask-close').click(function (e) {
    e.preventDefault()
    $('#subscription-body').removeClass('body-fixed')
    $('#cloud-mask').removeClass('display-block')
  })
  $('#cloud-mask').bind('click', function (e) {
    $('#subscription-body').removeClass('body-fixed')
    $('#cloud-mask').removeClass('display-block')
  })
  $('.mask-content').bind('click', function (e) {
    e.stopPropagation()
  })
})




// WEBPACK FOOTER //
// ./src/subscription/index.js